import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { CloseIcon, SearchIcon, NavigateArrowLeft } from '../../../../assets/svgs/icons'
import styles from './styles.module.css'

const NICHE_TRANSLATION_KEYS = {
  'Moda': 'chatsocket.niche.options.fashion',
  'Tecnologia': 'chatsocket.niche.options.technology',
  'Serviços': 'chatsocket.niche.options.services',
  'Varejo': 'chatsocket.niche.options.retail',
  'Entretenimento': 'chatsocket.niche.options.entertainment',
  'Beleza': 'chatsocket.niche.options.beauty',
  'Automotivo': 'chatsocket.niche.options.automotive',
  'Alimentos': 'chatsocket.niche.options.food',
  'Finanças': 'chatsocket.niche.options.finance',
  'Investimentos': 'chatsocket.niche.options.investments',
  'Educação': 'chatsocket.niche.options.education',
  'SaaS': 'chatsocket.niche.options.saas',
  'Pets': 'chatsocket.niche.options.pets',
  'Viagens': 'chatsocket.niche.options.travel',
  'Higiene': 'chatsocket.niche.options.hygiene',
  'Medicamentos': 'chatsocket.niche.options.medications',
  'Cursos': 'chatsocket.niche.options.courses',
  'Livros': 'chatsocket.niche.options.books',
  'Casa e Jardim': 'chatsocket.niche.options.home_garden',
  'Construção': 'chatsocket.niche.options.construction',
  'Internet': 'chatsocket.niche.options.internet',
  'Telecomunicações': 'chatsocket.niche.options.telecommunications',
  'Criptomoedas': 'chatsocket.niche.options.crypto',
  'Eletrônicos': 'chatsocket.niche.options.electronics',
  'Outro': 'chatsocket.niche.other_label',
}

const NICHE_OPTIONS = [
  'Moda',
  'Tecnologia',
  'Serviços',
  'Varejo',
  'Entretenimento',
  'Beleza',
  'Automotivo',
  'Alimentos',
  'Finanças',
  'Investimentos',
  'Educação',
  'SaaS',
  'Pets',
  'Viagens',
  'Higiene',
  'Medicamentos',
  'Cursos',
  'Livros',
  'Casa e Jardim',
  'Construção',
  'Internet',
  'Telecomunicações',
  'Criptomoedas',
  'Eletrônicos',
  'Outro'
]

export const NicheSelector = ({ isOpen, onClose, onSave }) => {
  const { t } = useTranslation()
  const [selectedNiche, setSelectedNiche] = useState(null)
  const [searchTerm, setSearchTerm] = useState('')
  const [subniche, setSubniche] = useState('')
  const [showOtherScreen, setShowOtherScreen] = useState(false)
  const [otherNiche, setOtherNiche] = useState('')

  if (!isOpen) return null

  const filteredNiches = NICHE_OPTIONS.filter(niche =>
    niche.toLowerCase().includes(searchTerm.toLowerCase())
  )

  const handleNicheSelect = (niche) => {
    setSelectedNiche(niche)
    if (niche === 'Outro') {
      setShowOtherScreen(true)
    }
  }

  const handleBack = () => {
    setShowOtherScreen(false)
    setSelectedNiche(null)
    setOtherNiche('')
  }

  const handleSave = () => {
    const niche = showOtherScreen ? otherNiche : selectedNiche
    if (onSave) {
      onSave({
        niche: niche || '',
        subniche: subniche || ''
      })
    }
    // Reset states
    setSelectedNiche(null)
    setSubniche('')
    setOtherNiche('')
    setShowOtherScreen(false)
    setSearchTerm('')
    onClose()
  }

  return (
    <div className={styles.container}>
      <div className={styles.modal}>
        {/* Header */}
        <div className={styles.header}>
          <h2 className={styles.title}>{t('chatsocket.niche.modal_title')}</h2>
          <button className={styles.closeButton} onClick={onClose}>
            <CloseIcon color="#000" size="20" />
          </button>
        </div>

        {!showOtherScreen ? (
          <>
            {/* Instruction */}
            <p className={styles.instruction}>{t('chatsocket.niche.instruction')}</p>

            {/* Search Bar */}
            <div className={styles.searchContainer}>
              <input
                type="text"
                className={styles.searchInput}
                placeholder={t('chatsocket.niche.search_placeholder')}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <SearchIcon width={20} height={20} color="#000" />
            </div>

            {/* Niche Options Grid */}
            <div className={styles.nicheGrid}>
              {filteredNiches.map((niche) => (
                <button
                  key={niche}
                  className={`${styles.nicheTag} ${
                    selectedNiche === niche ? styles.nicheTagSelected : ''
                  }`}
                  onClick={() => handleNicheSelect(niche)}
                >
                  {t(NICHE_TRANSLATION_KEYS[niche])}
                  {selectedNiche === niche && (
                    <span className={styles.checkmark}>✓</span>
                  )}
                </button>
              ))}
            </div>

            {/* Subniche Input */}
            <div className={styles.inputContainer}>
              <p className={styles.inputLabel}>{t('chatsocket.niche.subniche_label')}</p>
              <input
                type="text"
                className={styles.textInput}
                placeholder={t('chatsocket.niche.subniche_placeholder')}
                value={subniche}
                onChange={(e) => setSubniche(e.target.value)}
              />
            </div>
          </>
        ) : (
          <>
            {/* Back button and selected niche */}
            <div className={styles.backContainer}>
              <button className={styles.backButton} onClick={handleBack}>
                <NavigateArrowLeft width={12} height={24} color="#000" />
              </button>
              <button
                className={`${styles.nicheTag} ${styles.nicheTagSelected}`}
                disabled
              >
                {t('chatsocket.niche.other_label')}
                <span className={styles.checkmark}>✓</span>
              </button>
            </div>

            {/* Other Niche Input */}
            <div className={styles.inputContainer}>
              <p style={{marginTop: '-18px'}} className={styles.inputLabel}>{t('chatsocket.niche.niche_placeholder')}</p>
              <input
                type="text"
                className={styles.textInput}
                placeholder={t('chatsocket.niche.subniche_placeholder')}
                value={otherNiche}
                onChange={(e) => setOtherNiche(e.target.value)}
              />
            </div>

            {/* Subniche Input */}
            <div className={styles.inputContainer}>
              <p className={styles.inputLabel}>{t('chatsocket.niche.subniche_label')}</p>
              <input
                type="text"
                className={styles.textInput}
                placeholder={t('chatsocket.niche.subniche_placeholder')}
                value={subniche}
                onChange={(e) => setSubniche(e.target.value)}
              />
            </div>
          </>
        )}

        {/* Save Button */}
        <button className={styles.saveButton} onClick={handleSave}>
          {t('chatsocket.buttons.save_response')}
        </button>
      </div>
    </div>
  )
}